
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  Stacks comprise a set of utilites leveraging the power of{' '}
  <a href="https://www.w3.org/TR/2018/CR-css-flexbox-1-20181119/">
    CSS flexbox
  </a>{' '}
  in order to give you the ability to build complex layouts.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <p>{`A stack is made of a container and of children, also called "items" here.`}</p>
    <h2>{`Nesting`}</h2>
    <p>{`A stack can be nested inside another stack, making it possible to create a wide range of layouts.`}</p>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`Use the stack utilities when you need to arrange components horizontally or vertically.`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`Don't use stacks when the layout you're aiming for depends on the grid.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;